<template>
  <DashboardShell
    v-model:show-welcome="showWelcomeDialog"
    :nav-items="menuItems"
    :missing-params="state.missingParams"
    :exporting="exporting"
    :welcome="{
      projectName,
      initializing: !isDuckDBInitialized,
      dataLoaded,
      apiProgress,
      totalApiRequests,
      queryString,
    }"
    @load="handleLoadDashboard"
    @copy-query-string="handleCopyQueryString"
    @export="exportDatabase"
    @toggle-theme="toggleTheme"
    @close-missing-params="handleMissingParams"
  >
    <template #default>
      <router-view
        @itemsUpdated="handleItemsUpdated"
      ></router-view>
    </template>

    <template #fab>
      <StatusFilterFab
        v-model="showFilterDialog"
        :theme="theme"
        :itemTypes="itemTypeOptions"
        :statusTemplates="statusTypeFilters.statusTemplates.value"
        :statusFilters="statusFilters"
        :itemTypeFilters="itemTypeFilters"
        :hasActiveFilter="statusTypeFilters.hasActiveFilter.value"
        :allFiltersSelected="statusTypeFilters.allFiltersSelected.value"
        @toggleStatus="statusTypeFilters.toggleStatus"
        @toggleType="statusTypeFilters.toggleType"
        @toggleAll="statusTypeFilters.toggleAll"
      />
    </template>
  </DashboardShell>
</template>

<script src="./model.js"></script>
<style src="./style.css"></style>
